export enum PublicationStatusEnum {
  PUBLISHED_ENTRANCE_EXAM_RESULTS = 1, // Опубликованы результаты вступительных экзаменов
  NOT_PUBLISHED_ENTRANCE_EXAM_RESULTS = 2, // Не опубликованы результаты вступительных экзаменов
  PUBLISHED_PAYMENT_FORM = 3 // Опубликована форма оплаты
}



// WEBPACK FOOTER //
// ./src/app/common/enums/publication-status.enum.ts